import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import createMarkup from 'helpers/createMarkup';
import Avatar from 'components/common/Avatar';
import {processRegistration} from "../../lib/api/registration";
import {toast} from "react-toastify";




const Notification = ({
  avatar,
  id,
  document_type_id,
  time,
  className,
  unread = false,
  flush = false,
  emoji,
  children
}) => {

  const navigate = useNavigate();

  const handleProcess = async (id, document_type_id) => {
    try {
      const routes = {
        7: '/registration',
        8: '/membership',
        9: '/termination',
        10: '/license',
        12: '/contract'
      };
      const basePath = routes[document_type_id];
      if (basePath) {
        navigate('/dummy', { replace: true });
        setTimeout(()=>{
          navigate(`${basePath}?t_id=${id}`);
        },10);

        //navigate(`${basePath}?t_id=${id}`);

      } else {
        console.warn('Nepoznat document_type_id:', document_type_id);
      }
    } catch (err) {
      console.error(err);
    }
  };

    return (
  <Link
    className={classNames(
      'notification',
      { 'notification-unread': unread, 'notification-flush': flush },
      className
    )}
    to="#"
    onClick={(e) => {
      e.preventDefault();
      handleProcess(id, document_type_id);
    }}
  >
    {avatar && (
      <div className="notification-avatar">
        <Avatar {...avatar} className="me-3" />
      </div>
    )}
    <div className="notification-body">
      <p className="mb-1" dangerouslySetInnerHTML={createMarkup(children)} />
      <span className="notification-time">
        {emoji && (
          <span className="me-2" role="img" aria-label="Emoji">
            {emoji}
          </span>
        )}
        {time}
      </span>
    </div>
  </Link>
);
}

Notification.propTypes = {
  avatar: PropTypes.shape(Avatar.propTypes),
  time: PropTypes.string.isRequired,
  className: PropTypes.string,
  unread: PropTypes.bool,
  flush: PropTypes.bool,
  emoji: PropTypes.string,
  children: PropTypes.node
};

export default Notification;
